export const toFixedFloored = (
  value: string | number,
  decimals: number
): string => {
  // Convert the input to a string if it's not already
  const numStr = typeof value === "number" ? value.toString() : value;

  // Split the string at the decimal point
  const [integerPart, decimalPart = ""] = numStr.split(".");

  // If no decimal part or decimals is 0, return the integer part
  if (decimals === 0) return integerPart;

  // Take the specified number of decimals from the decimal part
  const truncatedDecimal = decimalPart.slice(0, decimals);

  // Pad with zeros if necessary to ensure correct decimal length
  const paddedDecimal = truncatedDecimal.padEnd(decimals, "0");

  // Combine the integer part and the truncated/padded decimal part
  return `${integerPart}.${paddedDecimal}`;
};
